import { IContextualMenuItem } from "@fluentui/react";
import React from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../../src/taskpane/components/_v2/redux/storeMain";
import { SharePointFolderContentTypeIds } from "../../../src/taskpane/config/constants";
import { LanguageContext } from "../../../utilities/LocalizationModule";

export function useMenuItem_VersionAppRej(selectedItems: any[], waitFor: boolean, setIsCMVersionAppRejModalOpen: (isCMVersionAppRejModalOpen: boolean) => void, isInOneDrive: boolean) {
    const languageStrings = React.useContext(LanguageContext);

    const currentSharepointFolder = useSelector((state: RootState) => state.currentSharepointFolder);
    const userAccount = useSelector((state: RootState) => state.user.account);

    const [menuItem_VersionAppRej, setMenuItem_VersionAppRej] = React.useState<IContextualMenuItem>();

    const menuItem: IContextualMenuItem = {
        key: 'approveReject',
        disabled: waitFor === true,
        name: `${languageStrings.Approve}/${languageStrings.Reject}`,
        iconProps: { iconName: "CheckedOutByOther12" },
        onClick: () => {
            setIsCMVersionAppRejModalOpen(true);
        }
    }

    React.useEffect(() => {
        if (!isInOneDrive && selectedItems.length > 0) {
            if (!selectedItems.some(x => x?.EffectiveBasePermissions?.canApproveItems === false) &&
                !selectedItems.some(x => x?.EffectiveBasePermissions?.canCancelCheckout === false) &&
                isAllInPending() &&
                (checkedOutAllItems() || (selectedItems.every(x => x.CheckoutUser) && !selectedItems.some(x => x?.EffectiveBasePermissions?.canCancelCheckout === false))) &&
                selectedItems?.some(x => !x.ContentTypeId?.startsWith(SharePointFolderContentTypeIds.folder))
            ) {
                setMenuItem_VersionAppRej(menuItem);
            }
            else {
                setMenuItem_VersionAppRej(null);
            }
        }
        else {
            setMenuItem_VersionAppRej(null);
        }
    }, [selectedItems, waitFor, isInOneDrive, currentSharepointFolder, userAccount])

    const isAllInPending = () => {
        let results = true;
        selectedItems.forEach(item => {
            if (results && !(item['_ModerationStatus.'] && item['_ModerationStatus.'] === '2')) {
                results = false;
            }
        });

        return results;
    }

    const checkedOutAllItems = () => {
        let results = true;
        if (selectedItems.every(x => x.CheckoutUser)) {
            selectedItems.forEach(item => {
                item.CheckoutUser.forEach(checkedOutUser => {
                    if (checkedOutUser.email !== userAccount.username) {
                        results = false;
                    }
                });
            });
        } else {
            results = false;
        }

        return results;
    }

    return {
        menuItem_VersionAppRej
    }

}